import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function InlineTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-white text-gray-900 py-1.5 px-2.5 md:py-3 md:px-4 rounded-lg md:rounded-xl flex items-center justify-center gap-1.5 md:gap-3 border border-pastel-200 shadow-sm" data-id="element-191">
      <Clock className="w-3.5 h-3.5 md:w-5 md:h-5 animate-pulse text-pastel-600" data-id="element-192" />
      <span className="text-[10px] md:text-base font-medium" data-id="element-193">
        Oferta expira en:
      </span>
      <div className="flex items-center gap-0.5 md:gap-1 font-mono font-bold" data-id="element-194">
        <span className="bg-pastel-100 text-pastel-800 px-1 py-0.5 md:px-2 md:py-1 rounded text-xs md:text-xl" data-id="element-195">
          {formatTime(minutes)}
        </span>
        <span className="animate-pulse text-pastel-600 text-xs md:text-xl" data-id="element-196">
          :
        </span>
        <span className="bg-pastel-100 text-pastel-800 px-1 py-0.5 md:px-2 md:py-1 rounded text-xs md:text-xl" data-id="element-197">
          {formatTime(seconds)}
        </span>
      </div>
    </div>;
}